import axios from "axios";
import {getAPIEndpointUrl} from "./ServerRequestModifier";

export default axios.create({
    baseURL: getAPIEndpointUrl() + "/api",
    headers: {
        "Content-type": "application/json"
    }
})